import { useApi, useToaster, type ExpertCustomerStoryDetails, type CustomerStoryUpsertRequest } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useCreateCustomerStory() {
    const api = useApi();
    const toaster = useToaster();
    const queryClient = useQueryClient();

    return useMutation<ExpertCustomerStoryDetails, Error, CustomerStoryUpsertRequest>({
        mutationKey: ["expert", "customer-stories", "create"],
        mutationFn: (payload) => api.expert.createCustomerStory({ body: payload }),
        onSuccess: async (story) => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["expert", "customer-stories"] }),
                queryClient.invalidateQueries({ queryKey: ["expert", "customerStories"] }),
                queryClient.invalidateQueries({ queryKey: ["expert", "customer-stories", story.id] }),
            ]);
            toaster.create({ title: "Case study saved", type: "success" });
        },
        onError: (error) => {
            toaster.create({ title: error.message || "Failed to save case study", type: "error" });
        },
    });
}

export default useCreateCustomerStory;
